import { render, staticRenderFns } from "./CashFlowStatement-demowithdummydata.vue?vue&type=template&id=f1742756&scoped=true"
import script from "./CashFlowStatement-demowithdummydata.vue?vue&type=script&lang=js"
export * from "./CashFlowStatement-demowithdummydata.vue?vue&type=script&lang=js"
import style0 from "./CashFlowStatement-demowithdummydata.vue?vue&type=style&index=0&id=f1742756&prod&scoped=true&lang=css"
import style1 from "./CashFlowStatement-demowithdummydata.vue?vue&type=style&index=1&id=f1742756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1742756",
  null
  
)

export default component.exports